import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SpinnerModule } from "@spartacus/storefront";
import { LoginRedirectComponent } from "./login-redirect/login-redirect.component";


@NgModule({
  declarations: [LoginRedirectComponent],
  imports: [CommonModule, SpinnerModule],
  exports: [LoginRedirectComponent],
})
export class LoginRedirectModule {}
